import { ResponseService } from './response.service';
import { NotificationsService } from 'angular2-notifications';
import { LocalStorageService } from './../services/local-storage.service';
import { ReplaySubject } from 'rxjs/Rx';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';

@Injectable()
export class DomainsService {

  private _companyDomainNames = new ReplaySubject(1);
  private _companyDomains: ReplaySubject<any> = new ReplaySubject(1);

  constructor(
    private apiService: ApiService,
    private localStorageService: LocalStorageService,
    private notificationsService: NotificationsService,
    private responseService: ResponseService
  ) { }

  getAllCompanyDomains() {
    this.apiService.get('/company/' + this.localStorageService.get('company') + '/domain')
    // .map((res) => res.servers)
    .subscribe(
      (response) => {
        const domains = this.responseService.success(false, response, 'domains');
        this._companyDomainNames.next(domains);
      },
      (error) => {
        this.responseService.error(error);
      }
    );

    return this._companyDomainNames;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/domains.service.ts